import { ConfigProvider, notification } from "antd";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { I18nextProvider, useTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import "./styles/index.css";
import { store } from "./reduxStore/store";
import { router } from "./Routes/Router";

notification.config({ placement: "bottomRight" });

function App() {
  const { i18n } = useTranslation();

  return (
    <div className="App">
      <Provider store={store}>
        <ConfigProvider
          direction={i18n?.language === "ar" ? "rtl" : "ltr"}
          theme={{
            token: {
              colorPrimary: "#042C43",
            },
            components: {
              Select: {
                colorBorder: "#CDD5D9",
                borderRadius: 12,
                optionActiveBg: "#EFEBF9",
                optionSelectedBg: "#EFEBF9",
                controlOutlineWidth: 1,
              },
              Table: {
                rowSelectedBg: "#e6f4ff",
                rowSelectedHoverBg: "#bae0ff",
                headerBg: "#EFEBF9",
                headerColor: "#7D72B8",
              },
              Steps: {},
              Button: {
                defaultHoverBorderColor: "none",
                colorBgTextHover: "none",
                defaultHoverColor: "none",
              },
              Pagination: {
                itemActiveBg: "#EFEBF9",
              },
            },
          }}
        >
          <I18nextProvider i18n={i18n}>
            <DndProvider backend={HTML5Backend}>
              <RouterProvider router={router} />
            </DndProvider>
          </I18nextProvider>
        </ConfigProvider>
      </Provider>
    </div>
  );
}

export default App;
